import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { EnableFor } from '../../../../../../../../__legacy__/containers/EnableForRole';
import { IEditMarkingToolBl } from '../../EditMarkingTool.bl';
import { useEditMarkingToolPermissions } from '../../EditMarkingTool.permissions';
import { EditMarkingToolButton } from './EditMarkingToolButton';

interface IProps {
  markingToolId: string;
}

export const EditMarkingToolButtonContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(IEditMarkingToolBl.$);
  const permissions = useEditMarkingToolPermissions();

  const { projectId } = useParams<{ projectId: string }>();

  const handleShowModal = async (): Promise<void> => {
    await bl.showModalAsync(projectId, props.markingToolId);
  };

  return (
    <EnableFor hasPermission={permissions.canOpenEditMarkingToolModal()}>
      <EditMarkingToolButton onShowModal={handleShowModal} />
    </EnableFor>
  );
});
